import { all, call, delay, put, takeLatest } from 'redux-saga/effects';

import * as notificationActions from '@/shared/modules/notification/actions';
import config from '@/config';
import { getAudioPath } from '@/shared/config/routes';
import { processSpeechRequest } from '@/shared/services/api';
import * as playButtonActions from '../store/actions';
import { playButtonActionTypes } from '../store/constants';

import type { Action } from '@/shared/app';
import type { SongData } from '../types';

interface GetSongPayload {
	id: string | number;
	word: string;
	lang: string;
}

interface ApiError {
	response?: {
		data?: {
			error?: string;
		};
	};
}

export default function* playButtonSaga() {
	yield all([takeLatest(playButtonActionTypes.GET_SONG_REQUEST, handleGetSong)]);
}

export function* handleGetSong(action: Action<GetSongPayload>) {
	try {
		const { id, word, lang } = action.payload || {};

		if (id == null || !word || !lang) {
			yield put(playButtonActions.removeSong());
			return;
		}

		if (!config.enable_speak_audio) {
			yield put(playButtonActions.removeSong());
			return;
		}

		const audioPath = getAudioPath(word);
		let { data }: { data: SongData } = yield call(processSpeechRequest, audioPath);
		while (!data?.url) {
			const response: { data: SongData } = yield call(processSpeechRequest, audioPath);
			yield delay(1000);
			data = response.data;
		}
		yield put(playButtonActions.getSongSuccess(id, data));
	} catch (e) {
		const error = e as ApiError;
		yield put(notificationActions.createNotification(error.response?.data?.error, null, true, 5000));
		yield put(playButtonActions.removeSong());
	}
}
